import styled from '@emotion/styled'
import * as v from '../../../../../variables/styles'

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const ContDetail = styled.div((props)=>({
  display:'flex',
  marginTop:'1rem',
  flexDirection:'column',

  '>div':{
    display:'flex',
    justifyContent:'flex-end',
  },

  '>div>div:first-child':{
    paddingRight:'1rem',
    fontWeight:'bold'
  },

  '>div>div:last-child':{
    marginLeft:'0.5rem'
  },

}))